/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DynacareModule
 */
export interface DynacareModule {
    /**
     * 
     * @type {boolean}
     * @memberof DynacareModule
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DynacareModule
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof DynacareModule
     */
    password?: string;
}

/**
 * Check if a given object implements the DynacareModule interface.
 */
export function instanceOfDynacareModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DynacareModuleFromJSON(json: any): DynacareModule {
    return DynacareModuleFromJSONTyped(json, false);
}

export function DynacareModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynacareModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function DynacareModuleToJSON(value?: DynacareModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'username': value.username,
        'password': value.password,
    };
}

